module.exports = {
  __depends__: [
    require(159)
  ],
  __init__: [ 'bpmnDistributeElements' ],
  bpmnDistributeElements: [ 'type', require(15) ]
};
